import { shallowEqual, useSelector } from 'react-redux'

import { selectUserData } from 'features/auth/selectors'

export const useUserInfo = () => {
  const userData = useSelector(selectUserData, shallowEqual)

  return {
    username: userData?.username,
    email: userData?.email,
  }
}
